import React, { useCallback, useEffect, useRef, useState } from 'react'
import { CRow, CCol, CCard, CCardBody } from '@coreui/react-pro'
import CIcon from '@coreui/icons-react'
import { cilBuilding } from '@coreui/icons'
import SponsorService from 'src/service/SponsorService'
import GameSponsorTable from './GameSponsorTable'

// Game-level sponsors: the hub owns the records, this game only turns them on and off.
const GameSponsorsPanel = ({ onTotalChange }) => {
  const [users, setUsers] = useState([])
  const [loading, setLoading] = useState(false)
  const [activePage, setActivePage] = useState(1)
  const [itemsPerPage, setItemsPerPage] = useState(10)
  const [columnFilter, setColumnFilter] = useState({})

  const onTotalChangeRef = useRef(onTotalChange)
  useEffect(() => {
    onTotalChangeRef.current = onTotalChange
  }, [onTotalChange])

  const fetchUsers = useCallback(async () => {
    setLoading(true)
    const offset = itemsPerPage * activePage - itemsPerPage
    let params = new URLSearchParams()
    params.append('sponsor_scope', 'game')
    Object.keys(columnFilter).forEach((key) => {
      params.append(key, columnFilter[key])
    })

    try {
      const result = await SponsorService.gameSponsorListing(
        offset,
        itemsPerPage,
        activePage,
        params,
      )
      setUsers(result.data)
      onTotalChangeRef.current?.(result.data?.total)
    } catch (error) {
      console.error('Error fetching sponsors:', error)
    } finally {
      setLoading(false)
    }
  }, [activePage, itemsPerPage, columnFilter])

  useEffect(() => {
    fetchUsers()
  }, [fetchUsers])

  return (
    <>
      <CRow className="g-3 mb-3">
        <CCol sm={6} lg={4}>
          <CCard className="h-100">
            <CCardBody className="d-flex justify-content-between align-items-center">
              <div>
                <div className="text-medium-emphasis small">Total Sponsors</div>
                <div className="fs-4 fw-semibold">{users?.total ?? 0}</div>
              </div>
              <div
                className="d-flex align-items-center justify-content-center rounded-circle bg-primary-subtle text-primary"
                style={{ width: 42, height: 42 }}
              >
                <CIcon icon={cilBuilding} size="lg" />
              </div>
            </CCardBody>
          </CCard>
        </CCol>
      </CRow>

      <CCard>
        <CCardBody>
          <GameSponsorTable
            users={users}
            fetchUsers={fetchUsers}
            setActivePage={setActivePage}
            setItemsPerPage={setItemsPerPage}
            setColumnFilter={setColumnFilter}
            itemsPerPage={itemsPerPage}
            activePage={activePage}
            loading={loading}
          />
        </CCardBody>
      </CCard>
    </>
  )
}

export default GameSponsorsPanel
